import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "submitButton"]
  static values = { detachUrl: String, moveUrl: String }

  toggle() {
    const moving = this.selectTarget.value !== ""

    this.element.action = moving ? this.moveUrlValue : this.detachUrlValue
    this.element.querySelector("input[name='_method']").value = moving ? "post" : "delete"

    this.submitButtonTarget.textContent = moving ? "Move" : "Detach"
    this.submitButtonTarget.classList.toggle("btn-warning", !moving)
    this.submitButtonTarget.classList.toggle("btn-primary", moving)
  }

  cancel() {
    this.element.closest("dialog").close()
  }
}
